import { useMemo, useState } from "react";
import Select from "react-select";
import type { Partner } from "../../dto/commons";
import { usePartners } from "../../hooks/use-commons";

interface Props {
  id?: string;
  value?: Partner[];
  onChange?: (newValue: Partner[]) => void;
  placeholder?: string;
  type: "customer" | "supplier";
}

export function PartnerSelector({
  id = "partnerSelector",
  placeholder = "All Partner",
  value,
  onChange,
  type,
}: Props) {
  const [_selected, _setSelected] = useState<Partner[]>(value || []);

  const selected = value ?? _selected;
  const { data, isLoading } = usePartners({ type });

  const partnerOptions = useMemo(
    () => data?.map((d) => ({ label: d.name, value: d.id })) || [],
    [data],
  );

  const handleChange = (selected: Partner[]) => {
    if (value === undefined) {
      _setSelected(selected);
    }
    onChange?.(selected);
  };

  return (
    <Select
      id={id}
      options={partnerOptions}
      isMulti
      isLoading={isLoading}
      placeholder={placeholder}
      value={partnerOptions.filter((option) =>
        selected.some((b) => b.id === option.value),
      )}
      classNames={{
        control: () => "!border-gray-200",
      }}
      onChange={(selectedOptions) => {
        handleChange(
          selectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        );
      }}
      className="mt-1"
    />
  );
}
